<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';
	import BaseButton from './baseButton.svelte';
	import type { ButtonSize } from './types';
	import type { Snippet } from 'svelte';

	type IconButtonSize = Exclude<ButtonSize, 'small'>;

	interface Props extends HTMLAttributes<HTMLButtonElement | HTMLAnchorElement> {
		size?: IconButtonSize;
		wrapperClass?: string;
		colorClass?: string;
		btn?: HTMLButtonElement | HTMLAnchorElement;
		children?: Snippet;
	}

	let {
		size = 'medium',
		colorClass = 'bg-green-1 text-green-5',
		wrapperClass,
		btn = $bindable(),
		children,
		...other
	}: Props = $props();

	const paddings: Record<IconButtonSize, number> = {
		medium: 8,
		large: 12,
		'extra-large': 12
	};

	let padding = $derived(paddings[size]);
	let paddingVar = $derived(`--padding-value:${padding}px`);
</script>

<BaseButton
	{...other}
	{wrapperClass}
	bind:btn
	style={paddingVar}
	class={[
		'btn-icon aspect-square origin-center touch-manipulation rounded-full transition-all duration-600',
		colorClass
	]}
	{children}
></BaseButton>

<style lang="scss">
	:global(.btn-icon) {
		padding: var(--padding-value);

		@media (min-width: 1024px) {
			&:hover {
				transform: scale3d(1.16, 1.16, 1);
			}
		}
	}
</style>
